import * as React from 'react';
import style from './MixesIn.scss';
import { Text } from '../../../PageElements/Text';
import { getTypesElements } from '../utils';
import { LoggerContext } from '../../../../appContext/LoggerProvider';
import { StoreContext } from '../../../../appContext/StoreProvider';

export const MixesIn = ({ items = [] }) => {
  const { logger } = React.useContext(LoggerContext);
  const { store } = React.useContext(StoreContext);
  return (
    <div className={style.inheritedProps}>
      <Text
        weight="bold"
        dataHook="mixes-in-title"
        tagName="span"
        className={style.mixesInTitle}
      >
        Mixes in:
      </Text>
      <ul>{getTypesElements(items, logger, store)}</ul>
    </div>
  );
};
